export default state => state.savedItems.showNotificationsOptInSuccess === true;
